
import { LOAD_MENU_ITEM } from "@/consts";
import LoadTable from "@/components/barcodeSystem/load/LoadTable.vue";
import LoadFilters from "@/components/barcodeSystem/load/LoadFilters.vue";
import LoadsActions from "@/components/barcodeSystem/load/LoadsActions.vue";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import LoadModule from "@/store/modules/barcodeSystem/load";
import Component from "vue-class-component";

const loadModuleState = getModule(LoadModule);

@Component({
  components: {
    LoadTable,
    LoadsActions,
    LoadFilters
  }
})
export default class Loads extends Vue {
  showInventorySummaryFieldFilter: boolean = false;
  truckMenuStyle: string = "";
  LOAD_MENU_ITEM: any = LOAD_MENU_ITEM;

  get fields() {
    return loadModuleState.fields;
  }

  async created() {
  }
  
  async loadMoreLoads() {
    await loadModuleState.setLoading(true);
    await loadModuleState.getLoads(null);
    await loadModuleState.setLoading(false);
  }

  async onSort(s) {
    await loadModuleState.setLoading(true);
    await loadModuleState.applyListSort(s);
    await loadModuleState.setLoading(false);
  }

  toggleChangeField(idx, hideShow) {
    loadModuleState.toggleField({ idx: idx, value: !hideShow });
  }

  get menuItemsToDisplay() {
    return this.LOAD_MENU_ITEM.filter(
      x => x.requiresPermission === undefined || this.hasPermission(x.requiresPermission)
    );
  }

  get dataRetreived() {
    if(loadModuleState.data)
      return true;
    return false;
  }
}


